import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-report-send-document',
  templateUrl: './report-send-document.component.html',
  styleUrls: ['./report-send-document.component.scss'],
})
export class ReportSendDocumentComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
